import gsap from "gsap/all"
import Parrallax from "./Parrallax";
import usefull from "./useful";



export default function ComponentTxtImg(){
    const component = document.querySelectorAll('.c-txt-img')
    if (component.length > 0) {
        component.forEach(comp => new TxtImg(comp))
    } 
}

class TxtImg {
    constructor(DOM) {
        this.DOM = DOM
        this.init();
    }

    init() {
        this.animation()
    }

    animation() {
        gsap.from(this.DOM.querySelectorAll('.c-txt-img__number, .a-txt-t02, .a-txt-p01, .a-word, [class^=c-txt-img__bg__] img'), {
            scrollTrigger: this.DOM,
            autoAlpha: 0,
            delay: 0.2,
            duration: 0.75,
            stagger: 0.25
        })
        this.parallax()
    }

    parallax() {
        let ratio = usefull.isTablet() ? -30 : -10;
        this.DOM.querySelector('.c-txt-img__number') && new Parrallax(this.DOM.querySelector('.c-txt-img__number'), ratio / 3);
        this.DOM.querySelector('[class^=c-txt-img__bg__] img') && new Parrallax(this.DOM.querySelector('[class^=c-txt-img__bg__] img'),  ratio);
    }
}
